import { Directive, inject, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

export interface TkContextWithImplicit<T> {
	$implicit: T;
}

/**
 * @internal
 */
export class LetContext<T> implements TkContextWithImplicit<T> {
	constructor(private readonly internalDirectiveInstance: LetDirective<T>) {}

	get $implicit(): T {
		return this.internalDirectiveInstance.tkLet;
	}

	get tkLet(): T {
		return this.internalDirectiveInstance.tkLet;
	}
}

@Directive({
	standalone: true,
	selector: '[tkLet]',
})
export class LetDirective<T> {
	@Input()
	tkLet!: T;
	@Inject(ViewContainerRef) viewContainer = inject(ViewContainerRef);
	@Inject(TemplateRef) templateRef = inject(TemplateRef<LetContext<T>>);

	constructor() {
		this.viewContainer.createEmbeddedView(this.templateRef, new LetContext<T>(this));
	}

	static ngTemplateContextGuard<T>(dir: LetDirective<T>, ctx: unknown): ctx is LetDirective<T> {
		return true;
	}
}
